var $ad8c9cad3dbd650f$exports = {};
$ad8c9cad3dbd650f$exports = {
    "backButton": (args)=>`Torna a ${args.prevMenuButton}`,
    "moreActions": `Altre azioni`,
    "unavailable": `Non disponibile, espandi per i dettagli`
};


export {$ad8c9cad3dbd650f$exports as default};
//# sourceMappingURL=it-IT.module.js.map
